import isEqual from "lodash/isEqual";
import omitBy from "lodash/omitBy";

export const diffValues = <T>(obj1: Partial<T>, obj2: Partial<T>) => {
  return omitBy(obj2, (value, key) => isEqual(value, obj1[key as keyof T]));
};
